<template>
	<div>
		<div v-if="use_credentials" class="mb-3">
			<small class="text-muted d-block mb-2">
				<i class="fas fa-key mr-1"></i>
				Les identifiants (serveur, login, mot de passe) sont gérés via les clés de sécurité de l'étape
				(bouton clé dans la barre d'outils ci-dessus).
			</small>
			<b-button size="sm" variant="outline-secondary" @click="reveal_fields">
				Renseigner les identifiants directement
			</b-button>
		</div>
		<template v-else>
			<b-form-group label="Serveur de mail" label-cols="3">
				<b-form-input v-model="host" placeholder="smtp.example.com" />
			</b-form-group>

			<b-form-group label="Login" label-cols="3">
				<b-form-input v-model="login" placeholder="utilisateur@example.com" />
			</b-form-group>

			<b-form-group label="Mot de passe" label-cols="3">
				<b-form-input type="password" v-model="pwd" />
			</b-form-group>

			<b-button size="sm" variant="link" class="p-0 mb-3" @click="use_credentials_instead">
				Utiliser les clés de sécurité de l'étape à la place
			</b-button>
		</template>

		<b-form-group label="Adresse expéditeur" label-cols="3">
			<b-form-input v-model="from" placeholder="expediteur@example.com" />
		</b-form-group>

		<b-form-group label="Adresse destinataire" label-cols="3">
			<b-form-input v-model="to" :list="'mail-to-cols-' + id" placeholder="Valeur fixe ou nom de colonne..." />
			<datalist :id="'mail-to-cols-' + id">
				<option v-for="col in availableColumnsList" :key="col" :value="col">{{ col }}</option>
			</datalist>
		</b-form-group>

		<b-form-group label="Colonne objet" label-cols="3" description="Nom de la colonne contenant l'objet du mail">
			<b-form-input v-model="subject" :list="'mail-subject-cols-' + id" placeholder="Nom de la colonne..." />
			<datalist :id="'mail-subject-cols-' + id">
				<option v-for="col in availableColumnsList" :key="col" :value="col">{{ col }}</option>
			</datalist>
		</b-form-group>

		<b-form-group label="Colonne corps" label-cols="3" description="Nom de la colonne contenant le corps du mail">
			<b-form-input v-model="content" :list="'mail-content-cols-' + id" placeholder="Nom de la colonne..." />
			<datalist :id="'mail-content-cols-' + id">
				<option v-for="col in availableColumnsList" :key="col" :value="col">{{ col }}</option>
			</datalist>
		</b-form-group>
	</div>
</template>

<script>
	import uniqueId from "lodash.uniqueid";

	const CREDENTIAL_PLACEHOLDERS = {
		host: "mail_host",
		login: "mail_login",
		pwd: "mail_pwd",
	};

	export default {
		name: "mail_step",
		props: {
			available_columns: {
				default: () => []
			},
			data: {
				default: () => []
			}
		},
		data() {
			return {
				id: uniqueId(""),
				use_credentials: true,
				host: "",
				login: "",
				pwd: "",
				from: "",
				to: "",
				subject: "",
				content: ""
			};
		},
		computed: {
			availableColumnsList() {
				var cols = this.available_columns || [];
				if (!cols.length && this.data && this.data.length > 0)
					cols = Object.keys(this.data[0]);
				return cols;
			}
		},
		methods: {
			reveal_fields() {
				this.use_credentials = false;
				this.host = "";
				this.login = "";
				this.pwd = "";
			},
			use_credentials_instead() {
				this.use_credentials = true;
			},
			save() {
				return {
					host: this.use_credentials ? CREDENTIAL_PLACEHOLDERS.host : this.host,
					login: this.use_credentials ? CREDENTIAL_PLACEHOLDERS.login : this.login,
					pwd: this.use_credentials ? CREDENTIAL_PLACEHOLDERS.pwd : this.pwd,
					from: this.from,
					to: this.to,
					subject: this.subject,
					content: this.content
				};
			},
			load(data) {
				if (!data) return;

				var is_placeholder = data.host === CREDENTIAL_PLACEHOLDERS.host
					&& data.login === CREDENTIAL_PLACEHOLDERS.login
					&& data.pwd === CREDENTIAL_PLACEHOLDERS.pwd;
				var has_direct_values = !!(data.host || data.login || data.pwd) && !is_placeholder;

				this.use_credentials = !has_direct_values;

				this.host = has_direct_values ? (data.host || "") : "";
				this.login = has_direct_values ? (data.login || "") : "";
				this.pwd = has_direct_values ? (data.pwd || "") : "";
				this.from = data.from || "";
				this.to = data.to || "";
				this.subject = data.subject || "";
				this.content = data.content || "";
			}
		}
	};
</script>
